/**
 * EllipseDate.js
 * Created by calhosh on 11/10/2020.
 */

import React from 'react';
import ReactMoment from 'react-moment';
import Moment from 'moment';
import EllipsesControl from './EllipsesControl';
import Utility from '../../../util/utilityfunctions';

const EllipsesMoment = (props) => {
	const {id, date, fromNow = false, lines = 1, useFormat = false, useLocal = false, userPreferences, className} = props;

	const momentLocale = fromNow ? true : false;
	const getLocalDate = () => {
		return Moment.utc(date).locale(Utility.getLocale(userPreferences));
	};

	return (
		<EllipsesControl
			id={id}
			className={className}
			content={
				<ReactMoment
					fromNow={fromNow}
					format={useFormat && Utility.getUserPreferencesDateValue(userPreferences, momentLocale)}
				>
					{useLocal ? getLocalDate() : date}
				</ReactMoment>
			}
			tooltip={
				<ReactMoment
					fromNow={fromNow}
					format={useFormat && Utility.getUserPreferencesDateValue(userPreferences, momentLocale)}
				>
					{useLocal ? getLocalDate() : date}
				</ReactMoment>
			}
			noOfLines={lines}
		/>
	);
};

export default EllipsesMoment;
